import { ArdoqId } from '@ardoq/api-types';

export const createReferenceIdFromParentAndChildId = (
  parentId: ArdoqId,
  childId: ArdoqId
) => `${parentId}-${childId}`;
